import './jumbotron-notable.scss';

import React from 'react';

import { cn } from '@sola/ark-core/utils/helpers.js';
import { FlexibleContentProps } from '@sola/schema/lib/schema.js';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.js';

import { Card } from '../../../molecules/card/card';
import { getBaseSizeProps } from '../../../utils/text-utils';

export const JumbotronNotable: React.FC<FlexibleContentProps> = ({
  seoLevel = 2,
  alt,
  inline,
  items: _items,
  ...props
}) => {
  const ratioClasses = {
    default: 'aspect-ratio-1 @md:aspect-ratio-16-9',
    alt: 'aspect-ratio-1 @md:aspect-ratio-16-9 @lg:aspect-ratio-21-9',
  };

  const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);

  return (
    <section
      className={cn('JumbotronNotable component--container', {
        'JumbotronNotable--alt': alt,
        component: !inline,
      })}
    >
      <div
        className={cn('JumbotronNotable__container flex', {
          container: !inline,
        })}
      >
        <Card
          {...props}
          {...getBaseSizeProps(headerDisplayLevel)}
          seoLevel={seoLevel}
          titleSize={seoLevel === 1 ? 'lg' : 'md'}
          variant="background"
          buttonVariant="grow"
          className={cn(
            'Card--single',
            alt ? ratioClasses.alt : ratioClasses.default,
          )}
          hasPlaceholder
          imageIntent="full"
        />
      </div>
    </section>
  );
};
